import http from './api'

const route = 'app/coletas/'

export default {
    showKmPercorrido: (dataInicial, dataFim, empresa, produtores, tokenContrato, linhasSelect) => {
      return http.post(route + 'showKmPercorrido', {
        dataInicio: dataInicial,
        dataFim: dataFim,
        empresa: empresa,
        produtor: produtores,
        tokenContrato: tokenContrato,
        linhasleite: linhasSelect,
      })
    },
    showKmPorColeta: (dataInicial, dataFim, empresa, produtores, tokenContrato, linhasSelect) => {
      return http.post(route + 'showKmPorColeta', {
        dataInicio: dataInicial,
        dataFim: dataFim,
        empresa: empresa,
        produtor: produtores,
        tokenContrato: tokenContrato,
        linhasleite: linhasSelect,
      })
    },
}
